// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MOBILE RESPONSIVE STYLES
   ============================================ */

/* ==================== WISH BADGE BASE STYLES ==================== */
/* Base styles for selected wish badges (applied on all screen sizes) */
.selected-wish-badge {
  display: inline-block;
  padding: 6px 45px 6px 25px;
  border-radius: 6px;
  color: white;
  font-size: 0.85rem;
  font-weight: 500;
  white-space: nowrap;
  box-sizing: border-box;
}

/* ==================== CARD GRID COLUMNS ==================== */
/* Mobile-only card grid column preferences */
@media (max-width: 768px) {
  .card-grid.mobile-1-col {
    grid-template-columns: 1fr !important;
    gap: var(--space-md);
  }

  .card-grid.mobile-2-col {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: var(--space-sm);
  }
}

/* Mobile breakpoint: tablets and phones */
@media (max-width: 768px) {

  /* Stack header elements vertically */
  .header-content {
    flex-direction: column !important;
    text-align: center;
    gap: var(--space-md);
  }

  .header-title {
    text-align: center;
    width: 100%;
  }

  .header-logo {
    font-size: var(--font-size-3xl) !important;
  }

  .header-subtitle {
    font-size: var(--font-size-base) !important;
  }

  .header-user-section {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }

  /* ==================== DATE MODAL ==================== */
  /* Make modal full width on mobile */
  .modal-card {
    max-width: 100% !important;
    width: 100% !important;
    max-height: 90vh !important;
    margin: 0 var(--space-sm);
  }

  /* Selected wishes - default 2 per line */
  .selected-wishes-container {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 4px !important;
    padding: var(--space-sm) !important;
  }

  /* 2 columns layout for wishes */
  .selected-wishes-container.wishes-2-col .selected-wish-badge {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 2px);
    max-width: calc(50% - 2px) !important;
    padding: 6px 45px 6px 25px !important;
    font-size: 0.8rem !important;
    box-sizing: border-box !important;
  }

  /* 1 column layout for wishes */
  .selected-wishes-container.wishes-1-col .selected-wish-badge {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding: 6px 45px 6px 25px !important;
    font-size: 0.8rem !important;
    box-sizing: border-box !important;
  }

  .selected-wish-badge button {
    width: 20px !important;
    height: 20px !important;
    font-size: var(--font-size-sm) !important;
  }

  /* Available wishes - always 2 per line */
  .available-wishes-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: var(--space-sm) !important;
  }

  /* ==================== TRADES ==================== */
  /* Stack trade items vertically */
  .trade-item,
  .proposal-item {
    flex-direction: column !important;
    gap: var(--space-md) !important;
  }

  /* Trade card display - stack content */
  .trade-item>div[style*="display: 'flex'"],
  .trade-item>div[style*="display: flex"] {
    flex-direction: column !important;
    gap: var(--space-md) !important;
  }

  /* Trade card image container */
  .trade-item>div>div[style*="flex: '0 0 200px'"],
  .trade-item>div>div[style*="flex: 0 0 200px"] {
    flex: none !important;
    width: 100% !important;
    max-width: 300px !important;
    margin: 0 auto !important;
  }

  /* Trade card content */
  .trade-item>div>div[style*="flex: 1"] {
    width: 100% !important;
  }

  /* Trade actions buttons */
  .trade-actions,
  div[style*="display: 'flex'"][style*="gap: '10px'"] button {
    width: 100% !important;
  }

  /* ==================== CARD FULL DETAILS ==================== */
  /* Card detail sections should stack */
  div[style*="display: 'grid'"][style*="gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr)'"],
  div[style*="display: grid"][style*="grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)"] {
    grid-template-columns: 1fr !important;
    gap: var(--space-md) !important;
  }

  /* Wishes display in card details */
  div[style*="display: 'grid'"][style*="gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr)'"],
  div[style*="display: grid"][style*="grid-template-columns: repeat(auto-fit, minmax(110px, 1fr)"] {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: var(--space-xs) !important;
  }

  /* ==================== MINIGAME (Guess Wish) ==================== */
  /* Wishes display in 2-3 columns */
  div[style*="gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr)'"],
  div[style*="grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)"] {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: var(--space-md) !important;
  }

  /* Game layout - stack vertically */
  div[style*="flexDirection: window.innerWidth <= 768 ? 'column' : 'row'"] {
    flex-direction: column !important;
    align-items: center !important;
  }

  /* Make game image responsive */
  .game-image,
  div[style*="maxHeight: '600px'"] img {
    max-width: 100% !important;
    max-height: 400px !important;
    height: auto !important;
  }

  /* ==================== GENERAL IMPROVEMENTS ==================== */
  /* Container padding */
  .container {
    padding: 0 var(--space-md) !important;
  }

  /* Page titles */
  .page-title {
    font-size: var(--font-size-2xl) !important;
  }

  /* Reduce font sizes slightly */
  h1 {
    font-size: var(--font-size-3xl) !important;
  }

  h2 {
    font-size: var(--font-size-2xl) !important;
  }

  h3 {
    font-size: var(--font-size-xl) !important;
  }

  /* Buttons - ensure touch-friendly sizes */
  button,
  .btn {
    min-height: 44px !important;
    min-width: 44px !important;
  }

  /* Form inputs - prevent iOS zoom */
  input[type="text"],
  input[type="email"],
  input[type="password"],
  input[type="number"],
  textarea,
  select {
    font-size: 16px !important;
  }

  /* Filter bars and control sections */
  .filter-bar,
  .section-header {
    flex-direction: column !important;
    gap: var(--space-md) !important;
  }

  .filter-group {
    width: 100% !important;
  }

  /* Stats rows */
  .stats-row {
    flex-direction: column !important;
    gap: var(--space-md) !important;
  }

  /* General grids */
  .grid-2,
  .grid-3,
  .grid-4 {
    grid-template-columns: 1fr !important;
  }

  /* Tabs */
  .tabs {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
    scrollbar-width: none !important;
  }

  .tabs::-webkit-scrollbar {
    display: none !important;
  }
}

/* Small phones - additional adjustments */
@media (max-width: 480px) {

  /* Even smaller header */
  .header-logo {
    font-size: var(--font-size-2xl) !important;
  }

  .header-subtitle {
    font-size: var(--font-size-sm) !important;
  }

  /* Tighter spacing */
  .modal-card {
    margin: 0 !important;
  }

  /* Minigame - still keep 2 columns but tighter */
  div[style*="gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr)'"],
  div[style*="grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)"] {
    gap: var(--space-sm) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/mobile-fixes.css"],"names":[],"mappings":"AAEA;;iDAEiD;;AAEjD,qEAAqE;AACrE,uEAAuE;AACvE;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE,6CAA6C;AAC7C;EACE;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,gDAAgD;IAChD,oBAAoB;EACtB;AACF;;AAEA,0CAA0C;AAC1C;;EAEE,qCAAqC;EACrC;IACE,iCAAiC;IACjC,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;;EAEA,yDAAyD;EACzD,oCAAoC;EACpC;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA,yCAAyC;EACzC;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,mBAAmB;IACnB,mCAAmC;EACrC;;EAEA,gCAAgC;EAChC;IACE,YAAoC;IAApC,cAAoC;IAApC,2BAAoC;IACpC,qCAAqC;IACrC,qCAAqC;IACrC,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA,+BAA+B;EAC/B;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,qCAAqC;IACrC,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,yCAAyC;EAC3C;;EAEA,yCAAyC;EACzC;IACE,gDAAgD;IAChD,+BAA+B;EACjC;;EAEA,qDAAqD;EACrD,iCAAiC;EACjC;;IAEE,iCAAiC;IACjC,+BAA+B;EACjC;;EAEA,uCAAuC;EACvC;;IAEE,iCAAiC;IACjC,+BAA+B;EACjC;;EAEA,+BAA+B;EAC/B;;IAEE,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA,uBAAuB;EACvB;IACE,sBAAsB;EACxB;;EAEA,0BAA0B;EAC1B;;IAEE,sBAAsB;EACxB;;EAEA,gEAAgE;EAChE,sCAAsC;EACtC;;IAEE,qCAAqC;IACrC,+BAA+B;EACjC;;EAEA,mCAAmC;EACnC;;IAEE,gDAAgD;IAChD,+BAA+B;EACjC;;EAEA,oEAAoE;EACpE,kCAAkC;EAClC;;IAEE,gDAAgD;IAChD,+BAA+B;EACjC;;EAEA,mCAAmC;EACnC;IACE,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA,+BAA+B;EAC/B;;IAEE,0BAA0B;IAC1B,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA,mEAAmE;EACnE,sBAAsB;EACtB;IACE,qCAAqC;EACvC;;EAEA,gBAAgB;EAChB;IACE,0CAA0C;EAC5C;;EAEA,+BAA+B;EAC/B;IACE,0CAA0C;EAC5C;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA,0CAA0C;EAC1C;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,mCAAmC;EACnC;;;;;;IAME,0BAA0B;EAC5B;;EAEA,qCAAqC;EACrC;;IAEE,iCAAiC;IACjC,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA,eAAe;EACf;IACE,iCAAiC;IACjC,+BAA+B;EACjC;;EAEA,kBAAkB;EAClB;;;IAGE,qCAAqC;EACvC;;EAEA,SAAS;EACT;IACE,2BAA2B;IAC3B,4CAA4C;IAC5C,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,0CAA0C;AAC1C;;EAEE,wBAAwB;EACxB;IACE,0CAA0C;EAC5C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA,oBAAoB;EACpB;IACE,oBAAoB;EACtB;;EAEA,gDAAgD;EAChD;;IAEE,+BAA+B;EACjC;AACF","sourcesContent":["@import './variables.css';\n\n/* ============================================\n   MOBILE RESPONSIVE STYLES\n   ============================================ */\n\n/* ==================== WISH BADGE BASE STYLES ==================== */\n/* Base styles for selected wish badges (applied on all screen sizes) */\n.selected-wish-badge {\n  display: inline-block;\n  padding: 6px 45px 6px 25px;\n  border-radius: 6px;\n  color: white;\n  font-size: 0.85rem;\n  font-weight: 500;\n  white-space: nowrap;\n  box-sizing: border-box;\n}\n\n/* ==================== CARD GRID COLUMNS ==================== */\n/* Mobile-only card grid column preferences */\n@media (max-width: 768px) {\n  .card-grid.mobile-1-col {\n    grid-template-columns: 1fr !important;\n    gap: var(--space-md);\n  }\n\n  .card-grid.mobile-2-col {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: var(--space-sm);\n  }\n}\n\n/* Mobile breakpoint: tablets and phones */\n@media (max-width: 768px) {\n\n  /* Stack header elements vertically */\n  .header-content {\n    flex-direction: column !important;\n    text-align: center;\n    gap: var(--space-md);\n  }\n\n  .header-title {\n    text-align: center;\n    width: 100%;\n  }\n\n  .header-logo {\n    font-size: var(--font-size-3xl) !important;\n  }\n\n  .header-subtitle {\n    font-size: var(--font-size-base) !important;\n  }\n\n  .header-user-section {\n    width: 100%;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  /* ==================== DATE MODAL ==================== */\n  /* Make modal full width on mobile */\n  .modal-card {\n    max-width: 100% !important;\n    width: 100% !important;\n    max-height: 90vh !important;\n    margin: 0 var(--space-sm);\n  }\n\n  /* Selected wishes - default 2 per line */\n  .selected-wishes-container {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    gap: 4px !important;\n    padding: var(--space-sm) !important;\n  }\n\n  /* 2 columns layout for wishes */\n  .selected-wishes-container.wishes-2-col .selected-wish-badge {\n    flex: 0 0 calc(50% - 2px) !important;\n    max-width: calc(50% - 2px) !important;\n    padding: 6px 45px 6px 25px !important;\n    font-size: 0.8rem !important;\n    box-sizing: border-box !important;\n  }\n\n  /* 1 column layout for wishes */\n  .selected-wishes-container.wishes-1-col .selected-wish-badge {\n    flex: 0 0 100% !important;\n    max-width: 100% !important;\n    padding: 6px 45px 6px 25px !important;\n    font-size: 0.8rem !important;\n    box-sizing: border-box !important;\n  }\n\n  .selected-wish-badge button {\n    width: 20px !important;\n    height: 20px !important;\n    font-size: var(--font-size-sm) !important;\n  }\n\n  /* Available wishes - always 2 per line */\n  .available-wishes-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: var(--space-sm) !important;\n  }\n\n  /* ==================== TRADES ==================== */\n  /* Stack trade items vertically */\n  .trade-item,\n  .proposal-item {\n    flex-direction: column !important;\n    gap: var(--space-md) !important;\n  }\n\n  /* Trade card display - stack content */\n  .trade-item>div[style*=\"display: 'flex'\"],\n  .trade-item>div[style*=\"display: flex\"] {\n    flex-direction: column !important;\n    gap: var(--space-md) !important;\n  }\n\n  /* Trade card image container */\n  .trade-item>div>div[style*=\"flex: '0 0 200px'\"],\n  .trade-item>div>div[style*=\"flex: 0 0 200px\"] {\n    flex: none !important;\n    width: 100% !important;\n    max-width: 300px !important;\n    margin: 0 auto !important;\n  }\n\n  /* Trade card content */\n  .trade-item>div>div[style*=\"flex: 1\"] {\n    width: 100% !important;\n  }\n\n  /* Trade actions buttons */\n  .trade-actions,\n  div[style*=\"display: 'flex'\"][style*=\"gap: '10px'\"] button {\n    width: 100% !important;\n  }\n\n  /* ==================== CARD FULL DETAILS ==================== */\n  /* Card detail sections should stack */\n  div[style*=\"display: 'grid'\"][style*=\"gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr)'\"],\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)\"] {\n    grid-template-columns: 1fr !important;\n    gap: var(--space-md) !important;\n  }\n\n  /* Wishes display in card details */\n  div[style*=\"display: 'grid'\"][style*=\"gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr)'\"],\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: repeat(auto-fit, minmax(110px, 1fr)\"] {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: var(--space-xs) !important;\n  }\n\n  /* ==================== MINIGAME (Guess Wish) ==================== */\n  /* Wishes display in 2-3 columns */\n  div[style*=\"gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr)'\"],\n  div[style*=\"grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)\"] {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: var(--space-md) !important;\n  }\n\n  /* Game layout - stack vertically */\n  div[style*=\"flexDirection: window.innerWidth <= 768 ? 'column' : 'row'\"] {\n    flex-direction: column !important;\n    align-items: center !important;\n  }\n\n  /* Make game image responsive */\n  .game-image,\n  div[style*=\"maxHeight: '600px'\"] img {\n    max-width: 100% !important;\n    max-height: 400px !important;\n    height: auto !important;\n  }\n\n  /* ==================== GENERAL IMPROVEMENTS ==================== */\n  /* Container padding */\n  .container {\n    padding: 0 var(--space-md) !important;\n  }\n\n  /* Page titles */\n  .page-title {\n    font-size: var(--font-size-2xl) !important;\n  }\n\n  /* Reduce font sizes slightly */\n  h1 {\n    font-size: var(--font-size-3xl) !important;\n  }\n\n  h2 {\n    font-size: var(--font-size-2xl) !important;\n  }\n\n  h3 {\n    font-size: var(--font-size-xl) !important;\n  }\n\n  /* Buttons - ensure touch-friendly sizes */\n  button,\n  .btn {\n    min-height: 44px !important;\n    min-width: 44px !important;\n  }\n\n  /* Form inputs - prevent iOS zoom */\n  input[type=\"text\"],\n  input[type=\"email\"],\n  input[type=\"password\"],\n  input[type=\"number\"],\n  textarea,\n  select {\n    font-size: 16px !important;\n  }\n\n  /* Filter bars and control sections */\n  .filter-bar,\n  .section-header {\n    flex-direction: column !important;\n    gap: var(--space-md) !important;\n  }\n\n  .filter-group {\n    width: 100% !important;\n  }\n\n  /* Stats rows */\n  .stats-row {\n    flex-direction: column !important;\n    gap: var(--space-md) !important;\n  }\n\n  /* General grids */\n  .grid-2,\n  .grid-3,\n  .grid-4 {\n    grid-template-columns: 1fr !important;\n  }\n\n  /* Tabs */\n  .tabs {\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n    scrollbar-width: none !important;\n  }\n\n  .tabs::-webkit-scrollbar {\n    display: none !important;\n  }\n}\n\n/* Small phones - additional adjustments */\n@media (max-width: 480px) {\n\n  /* Even smaller header */\n  .header-logo {\n    font-size: var(--font-size-2xl) !important;\n  }\n\n  .header-subtitle {\n    font-size: var(--font-size-sm) !important;\n  }\n\n  /* Tighter spacing */\n  .modal-card {\n    margin: 0 !important;\n  }\n\n  /* Minigame - still keep 2 columns but tighter */\n  div[style*=\"gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr)'\"],\n  div[style*=\"grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)\"] {\n    gap: var(--space-sm) !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
